import { useCallback } from "react"
import { useLocation } from "react-router-dom"
import { Location } from 'history'

const bookmarkKey = '_OD_LOCATION_BOOKMARK_'

export const useSaveLocationBookmark = () => {
  const location = useLocation()

  const saveBookmark = useCallback(() => {
    window.localStorage.setItem(bookmarkKey, JSON.stringify(location))
  }, [location])

  return saveBookmark
}

export const clearLocationBookmark = () => window.localStorage.removeItem(bookmarkKey)
export const readLocationBookmark = () => {
  const bookmark = window.localStorage.getItem(bookmarkKey)
  return bookmark ? (JSON.parse(bookmark) as Location) : null
}
